import './translate_text_modal.less';

import React, { Component } from 'react';
import autobind from 'class-autobind';

import noop from 'lodash/noop';

import TextInput from 'zoomforth_component_lib/basic_text_input.jsx';
import TextareaAutosize from 'zoomforth_component_lib/textarea_autosize.jsx';
import ConfirmSimpleModal from 'zoomforth_component_lib/confirm_simple_modal.jsx';
import { LoadingIcon } from 'zoomforth_component_lib/app_modern_icons.jsx';

import DefaultFroalaEditor from 'zoomforth_codesbane_editor/component_lib/default_froala_editor.jsx';

import { getLanguageLabelForIso } from 'translations/available_languages.js';


class TranslateTextModal extends Component {

  constructor(props) {
    super(props);

    this.state={
      tempTranslation: '',
      isTranslationReady: false
    };

    autobind(this);
  }

  componentDidMount() {
    this.props.onMount(this.handleTranslationCompleted);
  }

  handleTranslationCompleted(translatedText) {
    this.setState({
      isTranslationReady: true,
      tempTranslation: translatedText
    });
  }

  render() {
    const {
      text,
      froalaConfig,
      currentLanguageIso,
      defaultLanguageIso,
      shouldUseFroalaComponent,
      shouldUseTextAreaComponent,
      onTranslationSave,
      onClose
    } = this.props;

    const {
      tempTranslation,
      isTranslationReady
    } = this.state;

    const targetLanguageStr = getLanguageLabelForIso(currentLanguageIso);
    const sourceLanguageStr = getLanguageLabelForIso(defaultLanguageIso);

    return (
      <ConfirmSimpleModal 
        title="Auto-translate"
        style={{width: 500}}
        confirmText="Approve"
        cancelText="Cancel"
        closeOnOuterClick={true}
        keepOpenOnReturn={true}
        onConfirm={()=> {
          onTranslationSave(tempTranslation);
          this.setState({ tempTranslation: '' });
          onClose();
        }}
        onCancel={()=> {
          this.setState({ tempTranslation: '' });
          onClose();
        }}
      >
        {
          isTranslationReady ?

            shouldUseTextAreaComponent ?

            <TextareaDisplay
              sourceLanguageStr={sourceLanguageStr}
              targetLanguageStr={targetLanguageStr}
              srcText={text}
              targetText={tempTranslation}
              onTargetTextChange={(val)=>{
                this.setState({ tempTranslation: val });
              }}
            />

            :shouldUseFroalaComponent ?

            <FroalaDisplay
              froalaConfig={froalaConfig}
              sourceLanguageStr={sourceLanguageStr}
              targetLanguageStr={targetLanguageStr}
              srcText={text}
              targetText={tempTranslation}
              onTargetTextChange={(val)=>{
                this.setState({ tempTranslation: val });
              }}
            />

            :

            <TextInputDisplay
              sourceLanguageStr={sourceLanguageStr}
              targetLanguageStr={targetLanguageStr}
              srcText={text}
              targetText={tempTranslation}
              onTargetTextChange={(val)=>{
                this.setState({ tempTranslation: val });
              }}
            />

          :

            <LoadingIcon />

        }
      </ConfirmSimpleModal>
    );
  }

}

const TextareaDisplay = ({ sourceLanguageStr, targetLanguageStr, srcText, targetText, onTargetTextChange })=> (
  <div className="auto-translate-body">
    <div className="source-language">
      <label htmlFor="default-text-field">
        { sourceLanguageStr }
      </label>

      <span dangerouslySetInnerHTML={{__html: srcText }} />
    </div>

    <div className="target-language">
      <label htmlFor="target-text-field">
        { targetLanguageStr }
      </label>


      <TextareaAutosize
        value={targetText}
        onChange={(e)=> {
          onTargetTextChange(e.target.value);
        }}
      />
    </div>
  </div>
);

const TextInputDisplay = ({ sourceLanguageStr, targetLanguageStr, srcText, targetText, onTargetTextChange })=> (
  <div className="auto-translate-body">
    <div className="source-language">
      <label htmlFor="default-text-field">
        { sourceLanguageStr }
      </label>

      <TextInput name="default-text-field" disabled value={srcText} onChange={noop} />
    </div>

    <div className="target-language">
      <label htmlFor="target-text-field">
        { targetLanguageStr }
      </label>

      <TextInput
        name="target-text-field"
        value={targetText}
        onChange={(e)=> {
          onTargetTextChange(e.target.value);
        }}
      />
    </div>
  </div>
);

const FroalaDisplay = ({ froalaConfig, sourceLanguageStr, targetLanguageStr, srcText, targetText, onTargetTextChange })=> (
  <div className="auto-translate-body">
    <div className="source-language">
      <label htmlFor="default-text-field">
        { sourceLanguageStr }
      </label>

      <span dangerouslySetInnerHTML={{__html: srcText }} />
    </div>

    <div className="target-language">
      <label htmlFor="target-text-field">
        { targetLanguageStr }
      </label>

      <DefaultFroalaEditor 
        className="froala-editor-sidebar"
        config={froalaConfig}
        model={targetText}
        onModelChange={onTargetTextChange}
      >

        {/* Display html before user clicks and froala loads via initOnClick */}
        <span dangerouslySetInnerHTML={{__html: targetText }} />

      </DefaultFroalaEditor>
    </div>
  </div>
);

TranslateTextModal.defaultProps = {
  text: ''
};

export default TranslateTextModal;
